import { render, staticRenderFns } from "./PotentialCustomersList.vue?vue&type=template&id=6d4799ba&scoped=true&"
import script from "./PotentialCustomersList.vue?vue&type=script&lang=js&"
export * from "./PotentialCustomersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4799ba",
  null
  
)

export default component.exports